"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.StyledInput = exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledInput = _styledComponents.default.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: thin solid ", ";\n  color: ", ";\n  background-color: ", ";\n  padding: 5px 10px;\n  display: block;\n  width: 100%;\n  outline: none;\n  box-sizing: border-box;\n  border-radius: ", ";\n  box-shadow: -1px 1px 8px -2px ", ";\n  -webkit-box-shadow: -1px 1px 8px -2px ", ";\n  -moz-box-shadow: -1px 1px 8px -2px ", ";\n\n  ::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: ", ";\n    opacity: 1; /* Firefox */\n  }\n\n  :-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: ", ";\n  }\n\n  ::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: ", ";\n  }\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.color.border.primary;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.color.font.primary;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color.background.primary;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.border.radius;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.shadow;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.shadow;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.shadow;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.color.font.primary;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.color.font.primary;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.color.font.primary;
}, _ref11 => {
  var _theme$components, _theme$components$inp;

  let {
    theme
  } = _ref11;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$inp = _theme$components.input) === null || _theme$components$inp === void 0 ? void 0 : _theme$components$inp.input;
});

exports.StyledInput = StyledInput;

const Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  margin: ", ";\n  ", ";\n"])), _ref12 => {
  let {
    width
  } = _ref12;
  return width || '100%';
}, _ref13 => {
  let {
    margin
  } = _ref13;
  return margin || '0px';
}, _ref14 => {
  var _theme$components2, _theme$components2$in;

  let {
    theme
  } = _ref14;
  return theme === null || theme === void 0 ? void 0 : (_theme$components2 = theme.components) === null || _theme$components2 === void 0 ? void 0 : (_theme$components2$in = _theme$components2.input) === null || _theme$components2$in === void 0 ? void 0 : _theme$components2$in.wrapper;
});

exports.Wrapper = Wrapper;

const Label = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n  color: ", ";\n  ", ";\n"])), _ref15 => {
  let {
    theme,
    color
  } = _ref15;
  return color || theme.color.black;
}, _ref16 => {
  var _theme$components3, _theme$components3$in;

  let {
    theme
  } = _ref16;
  return theme === null || theme === void 0 ? void 0 : (_theme$components3 = theme.components) === null || _theme$components3 === void 0 ? void 0 : (_theme$components3$in = _theme$components3.input) === null || _theme$components3$in === void 0 ? void 0 : _theme$components3$in.label;
});

exports.Label = Label;